import React, { useState } from "react";
import { CreateNewCollectionModalProps } from "./types";
import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "@scenes/favorites/utils/collectionSchema";
import { FavoritesEnum } from "@scenes/favorites/utils/FavoritesUtils";
import { Button, Input, Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { useAddCollection } from "@apis/collection";

const CreateNewCollectionModal = ({
  isOpen,
  onClose,
  onSuccess,
}: CreateNewCollectionModalProps) => {
  const { t } = useTranslation();
  const { control, handleSubmit, setValue, watch } = useForm({
    resolver: yupResolver(schema),
  });
  const { theme, typography } = useScreenOptionsHooks();
  const addCollection = useAddCollection();
  const [isCollectionEventLoading, setCollectionEventLoading] = useState(false);

  const onSubmit = (mData: any) => {
    const alteredCollectionName = mData.collectionName.trim();
    addCollection.mutate(
      {
        name: alteredCollectionName,
        type: 5,
      },
      {
        onSuccess(data) {
          setCollectionEventLoading(false);
          onClose();
          setValue(FavoritesEnum.collection_name, "");
          onSuccess(data.data.collection);
        },
      }
    );
  };

  if (!isOpen) return null;

  return (
    <Modal
      headerTitle={t("favorites.createNewCollection.text")}
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setValue(FavoritesEnum.collection_name, "");
      }}
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={40}
      paddingTop={16}
    >
      <Controller
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            inputLabel={t("favorites.collectionName.text")}
            placeholder={t("favorites.collectionName.text")}
            hideIconContainer={true}
            onBlur={onBlur}
            onChangeText={(text) => {
              onChange(text.trimStart());
            }}
            value={value}
          />
        )}
        name={FavoritesEnum.collection_name}
      />
      <Spacer size={SpaceType.Big} />
      <VDBText color={theme["core-05"]} type={typography["Body-R"]}>
        {t("favorites.addItemsToDefaultCollection.text")}
      </VDBText>

      <Spacer size={SpaceType.Big} />

      <Button
        loading={isCollectionEventLoading}
        type={ButtonType.primary}
        disabled={!watch(FavoritesEnum.collection_name)}
        category={ButtonCategory.default}
        title={t("favorites.createNewCollection.text")}
        onPress={() => {
          setCollectionEventLoading(true);
          handleSubmit(onSubmit)();
        }}
      />
    </Modal>
  );
};

export default CreateNewCollectionModal;
